function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-1594774601706871",
  d: "M0,0v3.29427c0,0.82031 0.41172,1.58854 1.10234,2.05729l5.69766,4.23177v10.41667l3.4,-3.33333v-7.08333l5.69766,-4.23177c0.69062,-0.46875 1.10234,-1.23698 1.10234,-2.05729v-3.29427zM1.7,1.66667h13.6v1.62761c0,0.27344 -0.13945,0.52734 -0.37187,0.68359l-0.01328,0.00651l-5.85039,4.34896h-1.12891l-5.85039,-4.34896l-0.01328,-0.00651c-0.23242,-0.15625 -0.37187,-0.41016 -0.37187,-0.68359z"
}));

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 17 20",
    width: 17,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 90, 131)"
    },
    d: "M0,0v3.29427c0,0.82031 0.41172,1.58854 1.10234,2.05729l5.69766,4.23177v10.41667l3.4,-3.33333v-7.08333l5.69766,-4.23177c0.69062,-0.46875 1.10234,-1.23698 1.10234,-2.05729v-3.29427zM1.7,1.66667h13.6v1.62761c0,0.27344 -0.13945,0.52734 -0.37187,0.68359l-0.01328,0.00651l-5.85039,4.34896h-1.12891l-5.85039,-4.34896l-0.01328,-0.00651c-0.23242,-0.15625 -0.37187,-0.41016 -0.37187,-0.68359z"
  })), _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.e51e81cb.svg";
export { ForwardRef as ReactComponent };